import React from 'react';

const FeedbackItem = React.memo(({ feedback, formatDate }) => {
  return (
    <div className="border-l-4 border-blue-500 pl-4">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{feedback.employer}</span>
        <div className="flex items-center space-x-1">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={`text-sm ${i < feedback.rating ? 'text-yellow-400' : 'text-gray-300'}`}>
              ⭐
            </span>
          ))}
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-1">{feedback.comment}</p>
      <span className="text-xs text-gray-500">{formatDate(feedback.date)}</span>
    </div>
  );
});

export default FeedbackItem;
